import React, { Component } from 'react';
import Header from "./header";
import "./homePage.css";
import Footer from "./footer";
import { Responsive, Container, Grid, Image, Divider } from 'semantic-ui-react';
import BoardItem from "./boarditem";
class MemberList extends Component {
  state = {
    memberlist: [
      {
        "firstname": "Alex",
        "lastname": "LAU",
        "presidency": "President 2020/21",
        "classification": "Investment Banking",
        "year": 2014
      },
      {
        "firstname": "Alex",
        "lastname": "TSANG",
        "presidency": "",
        "classification": "Interior Design",
        "year": "2009 (Charter Member)"
      },
      {
        "firstname": "Amanda",
        "lastname": "CHAN",
        "presidency": "",
        "classification": "Insurance & Financial Planning",
        "year": 2026
      },
      {
        "firstname": "Arron",
        "lastname": "LAU",
        "presidency": "",
        "classification": "Medical - Physiotherapy",
        "year": 2026
      },
      {
        "firstname": "Bonnie",
        "lastname": "WONG",
        "presidency": "",
        "classification": "Asset Management",
        "year": 2015
      },
      {
        "firstname": "Clara",
        "lastname": "LI",
        "presidency": "",
        "classification": "Wealth Management",
        "year": 2024
      },
      {
        "firstname": "Constant",
        "lastname": "MO",
        "presidency": "President 2024/25",
        "classification": "Accounting",
        "year": 2019
      },
      {
        "firstname": "Derek",
        "lastname": "CHEUNG",
        "presidency": "",
        "classification": "Wealth Management",
        "year": 2018
      },
      {
        "firstname": "Edmond",
        "lastname": "CHAN",
        "presidency": "President 2021/22",
        "classification": "Construction Industry",
        "year": 2015
      },
      {
        "firstname": "Eric",
        "lastname": "CHIU",
        "presidency": "",
        "classification": "Asset Management",
        "year": 2025
      },
      {
        "firstname": "Eric",
        "lastname": "LUI",
        "presidency": "President 2023/24",
        "classification": "Medical - Physiotherapy",
        "year": "2009 (Charter Member)"
      },
      {
        "firstname": "Fonia",
        "lastname": "WONG",
        "presidency": "Charter President 2009/10",
        "classification": "Wealth Management",
        "year": "2009 (Charter Member)"
      },
      {
        "firstname": "Harriet",
        "lastname": "LI",
        "presidency": "",
        "classification": "Medical Laboratory Technology",
        "year": 2021
      },
      {
        "firstname": "Inez",
        "lastname": "WU",
        "presidency": "President 2025/26",
        "classification": "Consulting - Healthcare & Biotechnology",
        "year": "2009 (Charter Member)"
      },
      {
        "firstname": "Joey",
        "lastname": "CHAN",
        "presidency": "",
        "classification": "Law Practice",
        "year": 2022
      },
      {
        "firstname": "Karen",
        "lastname": "CHAN",
        "presidency": "President 2015/16",
        "classification": "Corporate Finance",
        "year": 2011
      },
      {
        "firstname": "Kent",
        "lastname": "LI",
        "presidency": "President 2026/27",
        "classification": "Civil Engineering",
        "year": 2012
      },
      {
        "firstname": "Krates",
        "lastname": "CHAN",
        "presidency": "",
        "classification": "Accounting",
        "year": 2024
      },
      {
        "firstname": "Mavis",
        "lastname": "CHAN",
        "presidency": "",
        "classification": "Digital Marketing",
        "year": 2022
      },
      {
        "firstname": "Olivia",
        "lastname": "CHOI",
        "presidency": "President 2012/13",
        "classification": "Tertiary Education - Statistics",
        "year": "2009 (Charter Member)"
      },
      {
        "firstname": "Ricky",
        "lastname": "SHAM",
        "presidency": "",
        "classification": "Manufacturing - Electronic Appliances",
        "year": "2009 (Charter Member)"
      },
      {
        "firstname": "Rita",
        "lastname": "KU",
        "presidency": "",
        "classification": "Law Practice",
        "year": 2022
      },
      {
        "firstname": "Rosenna",
        "lastname": "MAK",
        "presidency": "President 2019/20",
        "classification": "Corporate Advisory - Insolvency & Restructing",
        "year": 2011
      },
      {
        "firstname": "Shirley",
        "lastname": "TAM",
        "presidency": "President 2014/15",
        "classification": "Motor Insurance",
        "year": "2009 (Charter Member)"
      },
      {
        "firstname": "Simone",
        "lastname": "KONG",
        "presidency": "President 2022/23",
        "classification": "Law Practice",
        "year": 2016
      },
      {
        "firstname": "Vivian",
        "lastname": "CHOI",
        "presidency": "",
        "classification": "Accounting",
        "year": 2011
      },
      {
        "firstname": "Wallace",
        "lastname": "LAW",
        "presidency": "",
        "classification": "Wealth Management",
        "year": 2009
      },
      {
        "firstname": "Yemina",
        "lastname": "CHUNG",
        "presidency": "",
        "classification": "Medical - Veterinary Medicine & Chinese Opera",
        "year": 2026
      }
    ],
    honorablemembers: [
      {
        "firstname": "Alexander",
        "lastname": "MAK",
        "presidency": "District Governor 2004/05",
        "classification": "Taxation",
        "year": 2009
      },
      {
        "firstname": "Anthony",
        "lastname": "HUNG",
        "presidency": "District Governor 1998/99",
        "classification": "Law Practice",
        "year": 2009
      }
    ]
  }
  componentWillMount() {


  }
  render() {


    return (
      <div className="Homepage memberlistPage">

        <Header page="aboutus" />

        <div className="homeContentWhite">



          <a id="list">
            <Container>
              <div className="AboutUsTitle">
                Our Members
              </div>
              <div className="AboutUsText left">
                Membership to the club is by invitation only. We hope to bring positive energy to the society. Through our members' diverse life experience and expertise in different professions we aim to optimize such effect. Moreover, fellowship among members is equally important.
                <br /><br />
                We recruit members who share the same view --- to serve the community through hands-on participation, while serving the club through various committees and taking up leadership role in club planning and services, at the same time to enjoy the fun and satisfaction in the process.

              </div>
              <Divider hidden />
              <div className="memberlist">
                <Grid centered>
                  <Grid.Row>
                    <Grid.Column mobile={2} tablet={2} computer={2}>
                      <div className="BoardItemDate">First Name</div>
                    </Grid.Column>
                    <Grid.Column mobile={2} tablet={2} computer={2}>
                      <div className="BoardItemDate">Last Name</div>
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                      <div className="BoardItemDate">Presidency year</div>
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                      <div className="BoardItemDate">Classification</div>
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                      <div className="BoardItemDate">Year Admitted</div>
                    </Grid.Column>
                  </Grid.Row>
                  {this.state.memberlist.map((member, id) => {
                    return (
                      <Grid.Row>
                        <Grid.Column mobile={2} tablet={2} computer={2}>
                          <div className="BoardItemTitle">{member.firstname}</div>
                        </Grid.Column>
                        <Grid.Column mobile={2} tablet={2} computer={2}>
                          <div className="BoardItemTitle lastname">{member.lastname}</div>
                        </Grid.Column>
                        <Grid.Column mobile={4} tablet={4} computer={4}>
                          <div className="BoardItemTitle">{member.presidency}</div>
                        </Grid.Column>
                        <Grid.Column mobile={4} tablet={4} computer={4}>
                          <div className="BoardItemTitle">{member.classification}</div>
                        </Grid.Column>
                        <Grid.Column mobile={4} tablet={4} computer={4}>
                          <div className="BoardItemTitle">{member.year}</div>
                        </Grid.Column>
                      </Grid.Row>
                    )
                  })}


                </Grid>
              </div>

              <Divider hidden />
              <div className="AboutUsTitle">
                Honorable Members
              </div>
              <Divider hidden />
              <div className="memberlist">
                <Grid centered>
                  <Grid.Row>
                    <Grid.Column mobile={2} tablet={2} computer={2}>
                      <div className="BoardItemDate">First Name</div>
                    </Grid.Column>
                    <Grid.Column mobile={2} tablet={2} computer={2}>
                      <div className="BoardItemDate">Last Name</div>
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                      <div className="BoardItemDate">Presidency year</div>
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                      <div className="BoardItemDate">Classification</div>
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={4} computer={4}>
                      <div className="BoardItemDate">Year Admitted</div>
                    </Grid.Column>
                  </Grid.Row>
                  {this.state.honorablemembers.map((member, id) => {
                    return (
                      <Grid.Row>
                        <Grid.Column mobile={2} tablet={2} computer={2}>
                          <div className="BoardItemTitle">{member.firstname}</div>
                        </Grid.Column>
                        <Grid.Column mobile={2} tablet={2} computer={2}>
                          <div className="BoardItemTitle lastname">{member.lastname}</div>
                        </Grid.Column>
                        <Grid.Column mobile={4} tablet={4} computer={4}>
                          <div className="BoardItemTitle">{member.presidency}</div>
                        </Grid.Column>
                        <Grid.Column mobile={4} tablet={4} computer={4}>
                          <div className="BoardItemTitle">{member.classification}</div>
                        </Grid.Column>
                        <Grid.Column mobile={4} tablet={4} computer={4}>
                          <div className="BoardItemTitle">{member.year}</div>
                        </Grid.Column>
                      </Grid.Row>
                    )
                  })}
                </Grid>
              </div>
            </Container>
          </a>
        </div>

        <Footer />
      </div>
    );
  }
}

export default MemberList;
